module.exports = __webpack_public_path__ + "img/VIVO.73be11b5.svg";